import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import styles from '../assets/password-recovery-screen.module.scss';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { asyncPersistIntakeConsentForBi } from '../../../../../store/actions/intakeSent-actions';
import { push } from 'connected-react-router';
import Router from '../../../../../navigation/router';
import { routes } from '../../../../../navigation';
import { FieldSelectList } from '../../../../../components/redux-form/fields/FieldSelectList';

export interface ConsentForBiFormData {
    student: string;
    formId: string;

    isGiveConsentOne: any;
    parentNameOne: string;
    isGiveConsentTwo: any;
    parentNameTwo: string;
    isGiveConsentThree: any;
    parentNameThree: string;
}

interface ConsentForBiFormProps {
    initialValues: any;
    setIsLoader: any;
    setYesOne: any;
    yesOne: any;
    setYesTwo: any;
    yesTwo: any;
    setYesThree: any;
    yesThree: any;
}

type InjectedProps = InjectedFormProps<ConsentForBiFormData, ConsentForBiFormProps>;

const validators: Validators<ConsentForBiFormData> = {
    isGiveConsentOne: [maxLength({ max: 255 }), required({ message: "It's required." })],
    parentNameOne: [maxLength({ max: 255 })],
    isGiveConsentTwo: [maxLength({ max: 255 }), required({ message: "It's required." })],
    parentNameTwo: [maxLength({ max: 255 })],
    isGiveConsentThree: [maxLength({ max: 255 }), required({ message: "It's required." })],
    parentNameThree: [maxLength({ max: 255 })],
    //required({ message: "It's required." })
};

const ConsentForBiForm: React.FunctionComponent<InjectedProps & ConsentForBiFormProps> = ({
    handleSubmit,
    error,
    dirty,
    submitting,
    setYesOne,
    yesOne,
    setYesTwo,
    yesTwo,
    setYesThree,
    yesThree,
}: InjectedProps & ConsentForBiFormProps) => {
    const answerValues: SelectObject[] = [
        { label: 'Yes, I give consent to the item above', value: 1 },
        { label: "No, I don't give consent to the item above", value: 2 },
    ];

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <h2>ABA: Consent for BI, SPED</h2>
            <div style={{ textAlign: 'center' }}></div>
            <FormError error={error}/>
            <FieldInput
                name="student"
                type="hidden"
                wrapperConfig={{
                    label: '',
                }}
            />
            <FieldInput
                name="formId"
                type="hidden"
                value={3}
                wrapperConfig={{
                    label: '',
                }}
            />

            <div>
                1. I (parent and/or legal guardian) understand and consent to my child working with a Behavior
                Interventionist, who may be a master’s student or a recent graduate in Applied Behavior Analysis (ABA)
                or a closely related field such as counseling, social work, special education, or psychology. I
                acknowledge that while the Behavior Interventionist working directly with my child may not be a Board
                Certified Behavior Analyst (BCBA) or Licensed Behavior Analyst (LBA), all intervention services will be
                designed, overseen, and supervised by a BCBA. The supervising BCBA will be responsible for program
                development, training, and ongoing oversight to ensure the quality and effectiveness of the
                intervention. I consent to this arrangement and understand the roles and responsibilities of the
                professionals involved in my child’s care.
            </div>

            <div style={{ paddingTop: '20px' }}>
                <FieldSelectList
                    multiple={false}
                    name="isGiveConsentOne"
                    data={answerValues}
                    textField={'label'}
                    valueField={'value'}
                    onChange={(e: any) => {
                        if (e) {
                            if (e.value == 1) {
                                setYesOne(true);
                            } else {
                                setYesOne(false);
                            }
                        }
                    }}
                />
                <div className={yesOne ? '' : classNames(styles.hidden)}>
                    <FieldInput
                        name="parentNameOne"
                        type={yesOne ? 'text' : 'hidden'}
                        validate={validators.parentNameOne}
                        wrapperConfig={{
                            label: 'Enter your name and surname, please:',
                        }}
                    />
                </div>
            </div>

            <div style={{ paddingTop: '60px' }}>
                2. I (parent and/or legal guardian) understand and do not consent to my child working with a Certified
                Special Education Teacher who has received extensive training in the application of Behavior Analysis
                (ABA). I acknowledge that the Special Education Teacher will be responsible for program development and
                ongoing oversight.<br/><br/>
            </div>

            <div>
                <FieldSelectList
                    multiple={false}
                    name="isGiveConsentTwo"
                    data={answerValues}
                    textField={'label'}
                    valueField={'value'}
                    onChange={(e: any) => {
                        if (e) {
                            if (e.value == 1) {
                                setYesTwo(true);
                            } else {
                                setYesTwo(false);
                            }
                        }
                    }}
                />
                <div className={yesTwo ? '' : classNames(styles.hidden)}>
                    <FieldInput
                        name="parentNameTwo"
                        type={yesTwo ? 'text' : 'hidden'}
                        validate={validators.parentNameTwo}
                        wrapperConfig={{
                            label: 'Enter your name and surname, please:',
                        }}
                    />
                </div>
            </div>


            <div style={{ paddingTop: '60px' }}>
                3. I (parent and/or legal guardian) understand and consent to my child working with a Licensed Clinical
                Social Worker who has received extensive training in the application of Behavior Analysis (ABA). I
                acknowledge that the Licensed Clinical Social Worker will be responsible for program development and
                ongoing oversight.
                <br/><br/>
            </div>
            <div>
                <FieldSelectList
                    multiple={false}
                    name="isGiveConsentThree"
                    data={answerValues}
                    textField={'label'}
                    valueField={'value'}
                    onChange={(e: any) => {
                        if (e) {
                            if (e.value == 1) {
                                setYesThree(true);
                            } else {
                                setYesThree(false);
                            }
                        }
                    }}
                />
                <div className={yesThree ? '' : classNames(styles.hidden)}>
                    <FieldInput
                        name="parentNameThree"
                        type={yesThree ? 'text' : 'hidden'}
                        validate={validators.parentNameThree}
                        wrapperConfig={{
                            label: 'Enter your name and surname, please:',
                        }}
                    />
                </div>
            </div>

            <div className={classNames(styles.actionsButton)}>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave}/> Confirm and Send
                </button>
            </div>
        </form>
    );
};

export default reduxForm<ConsentForBiFormData, ConsentForBiFormProps>({
    form: 'consent-for-bi-form',
    enableReinitialize: true,
    onSubmit: async (data: ConsentForBiFormData, dispatch: Dispatch<any>, props: ConsentForBiFormProps) => {
        if (!data.isGiveConsentOne || data.isGiveConsentOne?.value === undefined) {
            toast.error('Please give consent to the below');
            return false;
        } else if (!data.isGiveConsentTwo || data.isGiveConsentTwo?.value === undefined) {
            toast.error('Please give consent to the below');
            return false;
        } else if (!data.isGiveConsentThree || data.isGiveConsentThree?.value === undefined) {
            toast.error('Please give consent to the below');
            return false;
        } else if (data.isGiveConsentOne?.value === 1 && !data.parentNameOne?.trim()) {
            toast.error('Please enter your name and surname');
            return false;
        } else if (data.isGiveConsentTwo?.value === 1 && !data.parentNameTwo?.trim()) {
            toast.error('Please enter your name and surname');
            return false;
        } else if (data.isGiveConsentThree?.value === 1 && !data.parentNameThree?.trim()) {
            toast.error('Please enter your name and surname');
            return false;
        } else {
            props.setIsLoader(true);
            await asyncPersistIntakeConsentForBi({ ...data }, dispatch);
            props.setIsLoader(false);
            dispatch(push(Router.generate(routes.INTAKE_PARENT_FORM_SUCCESS, {})));
        }
    },
    onChange: async (
        values: Partial<ConsentForBiFormData>,
        dispatch: Dispatch<any>,
        props: any,
        previousValues: Partial<ConsentForBiFormData>,
    ) => {},
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<ConsentForBiFormData, ConsentForBiFormProps, string>,
    ) {

    },

    onSubmitFail(errors: { _error: string }) {
        if (errors) {
            let field: any = null;
            Object.keys(errors).map((e: any, index: number, array: any) => {
                if (!field) {
                    field = e;
                    return;
                }
                return;
            });
            if (field) {
                const section = document.querySelector(`label[for='${field}']`);
                section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(ConsentForBiForm);
